import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-anchor-center-icon',
  templateUrl: './design-anchor-center.component.html'
})
export class DesignAnchorCenterComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
